/**
 * Table Search Highlighting Composable
 *
 * Provides functionality to highlight search terms in table cell text.
 * Creates computed values that inject HTML spans for visual highlighting.
 */

import type { Ref } from 'vue'
import { computed } from 'vue'

export const useTableSearchHighlighting = (searchTerm: Ref<string | number>) => {
	// Return a highlight function that computes the highlighted text
	const highlight = (text: string | number) => {
		return computed(() => {
			if (!text || !searchTerm.value) {
				return text
			}

			const term = searchTerm.value.toString().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&') // Escape special characters in searchTerm
			const regex = new RegExp(`(${term})`, 'gi') // Create a case-insensitive regex pattern
			const highlightedText = String(text).replace(regex, '<span class="bg-mx-orange/80 rounded-sm p-0.5 text-white font-semibold">$1</span>')
			return highlightedText
		})
	}

	return { highlight }
}
